import { render } from "./ContractContactBlockComponent.vue?vue&type=template&id=04be4d40&scoped=true"
import script from "./ContractContactBlockComponent.vue?vue&type=script&lang=js"
export * from "./ContractContactBlockComponent.vue?vue&type=script&lang=js"

import "./ContractContactBlockComponent.vue?vue&type=style&index=0&id=04be4d40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04be4d40"]])

export default __exports__